import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import React from "react";
import { FeaturesSection } from "./modules/FeaturesSection/FeaturesSection";
import { Footer } from "./modules/Footer/Footer";
import { PersonalNumberSection } from "./modules/PersonalNumberSection/PersonalNumberSection";

export const WhatsappIUnlockModal = ({ open, onClose }) => {
  return (
    <ExlyModal
      open={open}
      onClose={onClose}
      onClickCross={onClose}
      title={
        <div className="tw-text-[#2c207e] tw-text-[18px] tw-font-bold tw-leading-normal">
          Pay & Unlock: WhatsApp Personal Number
        </div>
      }
      customFooter={<></>}
      className="!tw-p-[24px] !tw-bg-[#eae7fa] tw-flex tw-flex-col tw-gap-[24px] max-md:tw-p-[16px]"
      modal_props={{ modalPaperClassName: "tw-min-w-[604px]" }}
    >
      <PersonalNumberSection />

      <FeaturesSection />

      <Footer onClose={onClose} />
    </ExlyModal>
  );
};
